import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { ImportOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import UIHelper from 'helpers/UIHelper';
import useCalendars from '../useCalendars';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    columns,
    data,
    loading,
    onChangeTableFilter,
    handleDownloadExcel,
    filters,
  } = useCalendars();
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={'FOOTFALL E CALENDARIO'}>
        <Row gutter={16}>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'import'}>
                <Button
                  big
                  type={'primary-white'}
                  iconMargin
                  width={'138px'}
                  icon={<ImportOutlined />}
                >
                  Importa
                </Button>
              </Link>
            </Col>
          )}
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              Esporta
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          rowKey='id'
          columns={columns}
          dataSource={UIHelper.assignTire(data.calendars)}
          pagination={data.pagination}
          scroll={{ x: 1000 }}
          onChange={onChangeTableFilter}
          loading={loading}
        />
      </div>
    </>
  );
};

export default MainPage;
